const ADD_TO_LIST = () => {};

const UPDATE_IN_LIST = () => {};

const REMOVE_FROM_LIST = () => {};

const CLEAR_LIST = () => {};

export default {
  ADD_TO_LIST,
  UPDATE_IN_LIST,
  REMOVE_FROM_LIST,
  CLEAR_LIST,
};
